// extracted by mini-css-extract-plugin
module.exports = {"sceneDuck":"CommonDuckScene_sceneDuck__6hJC8"};